<template>
	<div>
		<div>
			<a href="javascript:history.back()" class="btn btn-outline-secondary mr-2 mb-2" v-if="showBackLink">
				<font-awesome-icon icon="arrow-left"/>
				Vissza
			</a>
		</div>

		<div class="text-center">
			<div id="readme" class="Box-body readme blob js-code-block-container p-5 p-xl-6 gist-border-0">
				<article class="markdown-body entry-content container-lg">
					<p>The MIT License (MIT)</p>
					<p>Copyright (c) 2019 Federico Zivolo</p>
					<p>Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:</p>
					<p>The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.</p>
					<p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.</p>
				</article>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PopperLicenseView",
	data() {
		return {
			showBackLink: history.length > 1
		}
	}
}
</script>

<style scoped>

</style>
